import type { BonusCampaign } from '../../../api/fetchers/bonusPromotions/types/bonus';
import { DeviceInfo } from '../../../deviceInfo/deviceInfo';
import type { GameCommunicationSenderType } from '../../../services/gameCommunication/types';
import type { CoreStoreType } from '../../../store/CoreStore';
import type { IBetSpotValue, IBetSpots } from '../../../store/slices/bets/types';
import { ChipTypes } from '../../../store/slices/chips/types';

import { GameCommunicationBaseSender } from './GameCommunicationBaseSender';

export class GameCommunicationBetSender extends GameCommunicationBaseSender {
  name = 'Bet';

  send(
    _: never,
    store: CoreStoreType,
    sender: GameCommunicationSenderType,
    additionalParam?: string,
    overrideDefaults?: {
      gameName: string;
    }
  ): void {
    const state = store.getState();
    const gameChannel = state.gameState.gameChannel;
    const gameId = state.gameState.gameId;
    const gameName = overrideDefaults?.gameName ?? state.config.session?.gametype;
    const userId = state.config.playerConfig?.userId;
    const betStack = state.bets.betStack;
    const activeCampaign = state.bonusPromotions.activeBonusCampaign;
    const bets = betStack[betStack.length - 1]?.betSpots ?? {};
    const { isFreeBet, betTags } = this.createBetTags(bets);
    const freeBetParam = isFreeBet ? this.getFreeBetParams(activeCampaign) : '';
    const gameMode = `${gameName}_${DeviceInfo.deviceType()}`; // Required for UIC-2513

    if (gameChannel && userId) {
      let message = '';
      message += `<command channel="${gameChannel}">`;
      message += `<lpbet gm="${gameMode}" gId="${gameId}" uId="${userId}" ck="${Date.now()}" ${freeBetParam} ${additionalParam ?? ''}>`;
      message += betTags;
      message += '</lpbet>';
      message += '</command>';

      sender?.(message);
    }
  }

  protected createBetTags(bets: IBetSpots): { isFreeBet: boolean; betTags: string } {
    let isFreeBet = false;
    const betTags = Object.keys(bets).reduce((acc, betSpot) => {
      const currentBet = bets[betSpot];
      if (currentBet && currentBet.value > 0) {
        //if one free chip bet is found considering all bets as free bets. To be safe side in case of mixed bet.
        isFreeBet = isFreeBet || currentBet.type === ChipTypes.FreeChip;
        return acc + this.createBetTagByBetType(currentBet, betSpot);
      }
      return acc;
    }, '');
    return { isFreeBet, betTags };
  }

  protected createBetTagByBetType(currentBet: IBetSpotValue, betSpot: string): string {
    let params = `amt="${currentBet.value}" bc="${betSpot}" ck="${Date.now()}"`;
    if (currentBet.type === ChipTypes.FreeChip) {
      params += ` nc="${currentBet.count}"`;
    }
    return `<bet ${params}/>`;
  }

  protected getFreeBetParams(activeCampaign: BonusCampaign | null): string {
    if (activeCampaign) {
      const {
        requestId: rid,
        code,
        name,
        bonus: { chipValue },
      } = activeCampaign;
      let param = `bcode="${code}" bettype="${ChipTypes.FreeChip}" cv="${chipValue}" cn="${name}"`;
      if (rid) {
        param += ` rid="${rid}"`;
      }
      return param;
    }
    return '';
  }
}
